import clsx from 'clsx';
import React from 'react';

interface OnboardingFooterProps {
  otherClasses?: string;
}

const OnboardingFooter: React.FC<OnboardingFooterProps> = ({
  otherClasses,
}) => {
  const onboardingFooterClasses = clsx(
    otherClasses,
    'font-inter-variable flex flex-col items-center gap-1 text-center px-4 sm:px-0',
  );
  const date = new Date();
  const year = date.getFullYear();

  return (
    <footer className={onboardingFooterClasses} data-testid="onboarding-footer">
      <p className="text-neutral-tones-text/50 font-inter-variable -tracking-text-area text-xs leading-4 font-normal md:text-sm lg:text-lg lg:leading-5">
        By proceeding, you agree to our Terms of Use & Privacy Policy.
      </p>
      <span className="text-neutral-tones-text/50 -tracking-text-area font-inter-variable text-xs leading-4 font-normal md:text-sm lg:text-lg lg:leading-5">
        ©{year}, All rights reserved, EHS Navigator
      </span>
      <span className="text-neutral-tones-text/50 -tracking-text-area font-inter-variable text-xs leading-4 font-normal md:text-sm lg:text-lg lg:leading-5">
        Powered by{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="text-brand-byzantine block hover:underline lg:inline"
          href="https://anglebrackets.io/"
        >
          anglebrackets.io
        </a>
      </span>
    </footer>
  );
};

export default OnboardingFooter;
